module.exports = __webpack_public_path__ + "static/media/GOOGLE_POLISH_MALE.4f311581.mp3";